"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_AGGREGATED_PRODUCT_MEASURES = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_AGGREGATED_PRODUCT_MEASURES = (0, gql_1.gql)(`
  query AggregatedProductMeasures(
    $productTreeNodeId: ID!,
    $catalogId: ID!,
    $filter: ProductAggregatedMeasureListFilter,
    $sort: [ProductAggregatedMeasureOrderBy!],
    $first: Int,
    $last: Int,
    $before: ID,
    $after: ID,
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      productAggregatedMeasures(
        catalog: $catalogId,
        filter: $filter,
        sort: $sort,
        first: $first,
        last: $last,
        before: $before,
        after: $after,
      ) {
        edges {
          node {
            dimension
            productCount
          }
        }
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
`);
